var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsApplicationCostProfiler32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Application-Cost-Profiler_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Application-Cost-Profiler_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Application-Cost-Profiler_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.04669107,14 L7.10869107,14 C7.30669107,12.29 7.99669107,10.61 9.04569107,9.329 L9.04369107,4.015 C5.55169107,6.226 3.36269107,9.929 3.04669107,14 L3.04669107,14 Z M28.9986911,15 L29.9986911,15 C29.9986911,18.976 28.2996911,22.778 25.3356911,25.432 C22.9926911,27.53 20.1146911,28.735 17.0436911,28.956 L17.0436911,29 L16.0536911,29 C16.0426911,29 16.0316911,29.001 16.0216911,29.001 C15.4866911,29.001 14.9486911,28.972 14.4066911,28.912 C7.96969107,28.201 2.78769107,23.012 2.08469107,16.573 C1.46369107,10.878 4.29669107,5.433 9.30469107,2.702 L10.0436911,2.298 L10.0466911,15 L9.04669107,15 L9.04569107,11.118 C8.40869107,12.29 8.04369107,13.659 8.04369107,15 C8.04369107,19.411 11.6326911,23 16.0436911,23 C20.4546911,23 24.0436911,19.411 24.0436911,15 L25.0436911,15 C25.0436911,19.962 21.0066911,24 16.0436911,24 C11.0806911,24 7.04369107,19.962 7.04369107,15 L3.04369107,15 L3.04369107,14.046 C2.98469107,14.842 2.98969107,15.65 3.07869107,16.465 C3.73169107,22.441 8.54169107,27.258 14.5166911,27.918 C15.0286911,27.975 15.5376911,27.996 16.0436911,27.995 L16.0436911,24 L17.0436911,24 L17.0436911,27.95 C19.8686911,27.731 22.5126911,26.618 24.6686911,24.687 C27.4206911,22.223 28.9986911,18.691 28.9986911,15 L28.9986911,15 Z M29.0436911,13 L30.0436911,13 L30.0436911,6 L29.0436911,6 L29.0436911,13 Z M24.0436911,13 L25.0436911,13 L25.0436911,2 L24.0436911,2 L24.0436911,13 Z M19.0436911,18 L20.0436911,18 L20.0436911,8 L19.0436911,8 L19.0436911,18 Z M14.0436911,20 L15.0436911,20 L15.0436911,5 L14.0436911,5 L14.0436911,20 Z",
    id: "Fill-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsApplicationCostProfiler32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Application-Cost-Profiler_32.d347f552de0e9c610616b0e63c04690a.svg";
export { ForwardRef as ReactComponent };